if (!customElements.get('dnc-category-navigation')) {
  customElements.define('dnc-category-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.row = this.querySelector('[data-dnc-scroll-row]');
      if (!this.row) return;
      this.triggers = [...this.querySelectorAll('[data-dnc-trigger]')];
      this.querySelectorAll('[data-dnc-fallback]').forEach(link => { link.hidden = true; });
      this.triggers.forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => this.toggle(button), { signal });
        button.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            if (button.getAttribute('aria-expanded') !== 'true') this.toggle(button);
            document.getElementById(button.getAttribute('aria-controls'))?.querySelector('a')?.focus();
          }
        }, { signal });
      });
      this.querySelectorAll('[data-dnc-scroll]').forEach(button => {
        button.addEventListener('click', () => {
          this.close();
          this.row.scrollBy({ left: Number(button.dataset.dncScroll) * Math.max(160, this.row.clientWidth * 0.8), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
      });
      this.querySelectorAll('[data-dnc-close]').forEach(button => {
        button.addEventListener('click', () => this.close(true), { signal });
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.activeTrigger) { event.preventDefault(); this.close(true); }
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.close();
      }, { signal });
      document.addEventListener('focusin', event => {
        if (!this.contains(event.target)) this.close();
      }, { signal });
      this.row.addEventListener('scroll', () => this.updateArrows(), { passive: true, signal });
      this.observer = new ResizeObserver(() => this.updateArrows());
      this.observer.observe(this.row);
      document.fonts.ready.then(() => { if (this.isConnected) this.updateArrows(); });
      this.updateArrows();
    }
    updateArrows() {
      const previous = this.querySelector('[data-dnc-scroll="-1"]');
      const next = this.querySelector('[data-dnc-scroll="1"]');
      const overflow = this.row.scrollWidth - this.row.clientWidth;
      previous.hidden = overflow <= 2 || this.row.scrollLeft < 2;
      next.hidden = overflow <= 2 || this.row.scrollLeft >= overflow - 2;
      this.toggleAttribute('data-has-next', !next.hidden);
    }
    toggle(button) {
      const wasOpen = button.getAttribute('aria-expanded') === 'true';
      this.close();
      if (wasOpen) return;
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      button.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      this.activeTrigger = button;
    }
    close(restoreFocus = false) {
      const button = this.activeTrigger;
      this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      this.querySelectorAll('[data-dnc-panel]').forEach(panel => { panel.hidden = true; });
      this.activeTrigger = null;
      if (restoreFocus && button) button.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
}
